import { gql } from '@apollo/client';

/**
 * 提交一批 Phase 1.2 别名匹配缓存的预热任务。
 *
 * 按别名 id 区间分批扫描 address_alias + address_core，按 (别名, 邮编) 组合取最佳别名写入 Redis。
 *
 * **提交即返回，任务在后台异步执行**（满区间为分钟级，同步等会撞网关超时），
 * 故返回值只表示「有没有接下这一批」，各项计数需按 runId 检索服务端日志。
 * 全局互斥：上一批未跑完时直接回绝、不排队。
 * 服务端限制单次 id 跨度不超过 100000，超出会直接报错。
 */
export const WARM_UP_ALIAS_MATCH_CACHE = gql`
  mutation WarmUpAliasMatchCache($beginAliasId: Long!, $endAliasId: Long!) {
    warmUpAliasMatchCache(beginAliasId: $beginAliasId, endAliasId: $endAliasId) {
      accepted
      message
      runId
    }
  }
`;

export interface AliasMatchCacheWarmUpSubmitResult {
  /** 是否已接下本批任务；false 表示上一批仍在执行中，本次未做任何事 */
  accepted: boolean;
  /** 面向运维的说明文案，可直接展示 */
  message: string;
  /** 本轮任务 id，用于在日志中检索执行结果；未接下时为空串 */
  runId: string;
}
